/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: updateDataProfileCtrl
* # alias: updateVM
*/

export default class updateDataProfileCtrl {

	constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, perfilSrv, $cookies, moment, GlobalConfig,
		FileUploader, SERVICE_URL_CONSTANT, $window, $mdDialog, GlobalSrv) {
		var vm = this

		vm.$scope = $scope
		vm.$state = $state
		vm.$timeout = $timeout
		vm.ngNotify = ngNotify
		vm.$stateParams = $stateParams
		vm.info = this.$stateParams
		vm.globalConfig = GlobalConfig
		vm.services = perfilSrv
		vm.moment = moment
		vm.$cookies = $cookies
		vm.$window = $window
		vm.userinfo = null
		vm.$scope.UserInfoConstant = UserInfoConstant
		vm.main = main
		vm.getLogs = getLogs
		vm.getDataToUpdate = getDataToUpdate
		vm.getStagesList = getStagesList
		vm.setStageToData = setStageToData
		vm.getFile = getFile
		vm.activateModal = activateModal
		vm.downloadFileSrv = SERVICE_URL_CONSTANT.rosario + '/perfil/downloadFile'
		vm.messageFileType = false
		vm.messageFileSize = false
		vm.messageFileName = false
		vm.getFilesBitacora = getFilesBitacora
		vm.remove = remove
		vm.hasError = hasError
		vm.validateForm = validateForm
		vm.showErrorMessages = showErrorMessages
		vm.isSaveButtonDisabled = false
		vm.editDisabled = true
		vm.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
			if (details !== undefined) {
				vm.userinfo = details.user
				vm.userinfo.role_id = $cookies.get('hasRoleId')
				vm.main()
			}
		})
		vm.updateProfiles = GlobalConfig.idUpdateProfile
		vm.isExtension = vm.updateProfiles.extension === parseInt(vm.info.historyType)
		vm.isFormation = vm.updateProfiles.perfil_formacion === parseInt(vm.info.historyType)
		vm.isTrayectoriaUr = vm.updateProfiles.trayectoria_UR === parseInt(vm.info.historyType)
		vm.isReconocimiento = vm.updateProfiles.reconocimiento === parseInt(vm.info.historyType)
		vm.isPerfil = vm.updateProfiles.docencia == parseInt(vm.info.historyType)
		vm.isTrayectoriaPrevia = vm.updateProfiles.trayectoria_previa === parseInt(vm.info.historyType)

		//upload methods
		vm.$scope.uploader = new FileUploader({ url: SERVICE_URL_CONSTANT.rosario + '/perfil/uploadFileRequest' })

		// a sync filter
		vm.$scope.uploader.filters.push({
			name: 'syncFilter',
			fn  : function(item /*{File|FileLikeObject}*/, options) {
				console.log('syncFilter')

				return this.queue.length < 10
			},
		})

		// an async filter
		vm.$scope.uploader.filters.push({
			name: 'asyncFilter',
			fn  : function(item /*{File|FileLikeObject}*/, options, deferred) {
				console.log('asyncFilter')
				setTimeout(deferred.resolve, 1e3)
			},
		})
		vm.$scope.uploader.filters.push({
			name: 'typeFilter',
			fn  :	function (item) {
				console.log('typeFilter')

				if (/\/(pdf)$/.test(item.type)) {
					vm.messageFileType = false

					return true
				} else {
					vm.messageFileType = true
				}		
			},
		})

		vm.$scope.uploader.filters.push({
			name: 'sizeFilter',
			fn  : function (item) {
				console.log('sizeFilter')

				if (item.size <= 3145728) {
					vm.messageFileSize = false

					return true
				} else {
					vm.messageFileSize = true
				}
			},
		})
		vm.$scope.uploader.filters.push({
			name: 'nameFilter',
			fn  : function (item) {
				console.log('nameFilter')

				if (item.name.indexOf(' ') <= 0) {
					vm.messageFileName = false

					return true
				} else {
					vm.messageFileName = true
				}
			},
		})
		vm.$scope.uploader.onSuccessItem = function(fileItem, response, status, headers) {
			console.info('onSuccessItem', fileItem, response, status, headers)
		}
		vm.$scope.uploader.onErrorItem = function(fileItem, response, status, headers) {
			console.info('onErrorItem', fileItem, response, status, headers)
			vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
			vm.isSaveButtonDisabled = false
		}

		vm.$scope.uploader.onCompleteItem = function(fileItem, response, status, headers) {
			console.info('onCompleteItem', fileItem, response, status, headers)
			vm.$state.go('profile.Actualizacion_Perfil')
			vm.ngNotify.set('Perfil actualizado exitosamente!', 'success')
			vm.isSaveButtonDisabled = false
		}

		vm.$scope.uploader.onBeforeUploadItem = function(item) {
			let header = {
				userId: vm.userinfo.id,
			}

			item.formData.push(header)
			$scope.loading = true
		}

		function remove(index) {
			vm.$scope.uploader.queue[index].remove()
		}

		function main() {
			vm.getLogs()
			vm.getDataToUpdate()
		}

		function getLogs() {
			vm.services.perfildocente.getLogs({ ticketId: vm.info.nTicket }).$promise.then((response) => {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					console.log(response.data)
					vm.logs = response.data
				}
			}, (err) => {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}
		function getDataToUpdate() {
			vm.services.perfildocente.getDataToUpdate({ ticketId: vm.info.nTicket, teacherId: vm.info.idTeacher }).$promise.then((response) => {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					vm.dataToUpdate = response.data[0]
					vm.nmActa = vm.dataToUpdate.numActa_pf
					vm.dtActa = new Date(vm.dataToUpdate.dt_act_pf)
					vm.level = vm.dataToUpdate.nm_level_form_pf
					vm.descriptionEq = vm.dataToUpdate.equivDes_pf
					vm.identificationNumber = response.data[0].cedula
					let fechaCumple = moment(vm.dataToUpdate.fechaCumple)
					let currentBirthdate = moment(vm.dataToUpdate.currentBirthdate)

					if (vm.dataToUpdate.nm_validation_type) {
						vm.dataToUpdate.nm_validation_type = vm.dataToUpdate.nm_validation_type == 1 ? 'Convalidado ante el MEN' : 'Emitidio en español o con traducción oficial' 
					}

					vm.dataToUpdate.fechaCumple = fechaCumple.format('DD-MM-YYYY')
					vm.dataToUpdate.currentBirthdate = currentBirthdate.format('YYYY-MM-DD')

					vm.workflowClosed = isWorkflowClosed(vm.dataToUpdate.idEstado)

					if (((vm.userinfo.role_id == vm.globalConfig.userRolesIds.reviewerUpdatePerfil) && (response.reviewStatus == vm.dataToUpdate.idEstado))
						|| ((vm.userinfo.role_id == vm.globalConfig.userRolesIds.approverUpdatePerfil) && (response.approveStatus.includes(vm.dataToUpdate.idEstado)))
						|| ((vm.userinfo.role_id == vm.globalConfig.userRolesIds.teacher) && (response.completeStatus.includes(vm.dataToUpdate.idEstado)))) {
						vm.editDisabled = false
					} else {
						vm.editDisabled = true
					}

					vm.getStagesList()
				}
			}, (err) => {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}

		function getStagesList() {
			let params = {
				stageId       : vm.dataToUpdate.idEstado,
				typeId        : vm.dataToUpdate.idType,
				roleId        : vm.userinfo.role_id, 
				stageCurrentId: vm.dataToUpdate.idEstadoAnt, 
			}

			vm.services.listStage.getListStage(params).$promise.then((response) => {
				if (!response.status) {
					vm.ngNotify.set('Ocurrio un error en el servicio', 'warn')
				} else {
					vm.listStages = response.data
				}
			}, (err) => {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}

		function getNotifyPendienteDeAprobacion(idRole) {
			let usersByRol = []
			let header = { rolId: idRole }

			GlobalSrv.getUserByRol.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status == true) {
					usersByRol = dataReturn.data

					for (var i in usersByRol) {
						getSendNotifyPendienteDeAprobacion(usersByRol[i].id_user)
					}
				} else {
					console.log('Ocurrio un error en el servicio de notificación')
				}
			}, function(dataReturn) {
				console.log(dataReturn)
			})
		}

		function getSendNotifyPendienteDeAprobacion(idUser) {
			let data = {
				idUser                      : idUser,
				dsName                      : 'Notificación de una solicitud de aprobación',
				dsDescription               : 'Ha recibido una solicitud de aprobación y actualización para el profesor "' + vm.info.nameUser + '" por parte de la dirección académica.',
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
				is_grouped                  : 0,
			}

			GlobalSrv.sendNotification(data)
		}
		
		function getNotifyActualizacionRealizada(idRole) {
			let usersByRol = []
			let header = { rolId: idRole }

			GlobalSrv.getUserByRol.get(header).$promise.then(function (dataReturn) {
				if (dataReturn.status == true) {
					usersByRol = dataReturn.data

					for (var i in usersByRol) {
						getSendNotifyActualizacionRealizada(usersByRol[i].id_user)
					}
				} else {
					console.log('Ocurrio un error en el servicio de notificación')
				}
			}, function(dataReturn) {
				console.log(dataReturn)
			})
		}

		function getSendNotifyActualizacionRealizada(idUser) {
			let data = {
				idUser                      : idUser,
				dsName                      : 'Notificación de solicitud a actualización realizada',
				dsDescription               : 'La actualización solicitada fue realizada, puede consultar la información en el sistema.',
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
				is_grouped                  : 1,
			}

			GlobalSrv.sendNotification(data)
		}

		function isWorkflowClosed(stage) {
			if ([ 10, 11, 15, 16, 20, 21 ].includes(stage)) return true

			return false
		}

		function setStageToData() {
			vm.isSaveButtonDisabled = true
			var fileNames = []

			for (var i = 0 ; i < vm.$scope.uploader.queue.length; i++) {
				fileNames.push(vm.$scope.uploader.queue[i].file.name)
			}
			let params = {
				stageId       : vm.stage,
				currentStageId: vm.dataToUpdate.idEstado,
				idHistActiv   : vm.dataToUpdate.NTicket,
				userid        : vm.userinfo.id,
				description   : vm.description,
				nmActa        : vm.nmActa,
				dtActa        : moment(vm.dtActa).format('YYYY-MM-DD'),
				level         : vm.level,
				descriptionEq : vm.descriptionEq,
				fileNames     : fileNames,
			}

			var aCompletarSolicitud = false

			if (vm.stage == 12 || vm.stage == 17) //Completar Solicitud
			{
				aCompletarSolicitud = true
			}

			var aPendienteDeAprobacion = false

			if (vm.stage == 9 || vm.stage == 14) //Pendiente de Aprobación
			{
				aPendienteDeAprobacion = true
			}

			var aActualizacionRealizada = false

			if (vm.stage == 10 || vm.stage == 15) //Actualización Realizada
			{
				aActualizacionRealizada = true
			}            

			var aSolicitudRechazada = false

			if (vm.stage == 11 || vm.stage == 16) //Solicitud rechazada
			{
				aSolicitudRechazada = true
			}
            
			vm.services.post.saveChangeStage(params).$promise.then((response) => {
				if (response.status) {
					if (aCompletarSolicitud === true) {
						let post1 = {
							idUser                      : vm.info.idUser,
							dsName                      : 'Notificación de solicitud a completar solicitud',
							dsDescription               : 'Profesor: Debe completar su solicitud de actualización de perfil. Por favor valide las observaciones registradas.',
							idNotification_delivery_type: GlobalConfig.notificationType.inbox,
							is_grouped                  : 0,
						}

						vm.services.addNotificationsTransactions.add(post1).$promise.then(function (dataReturn) {
							if (dataReturn.status) {
								console.log('ok notification solicitud a completar solicitud', dataReturn)
							} else {
								console.log('Error Comunications')
							}
						}, function (data) {
							console.log(data)
						})
					}

					if (aPendienteDeAprobacion === true) {
						getNotifyPendienteDeAprobacion(GlobalConfig.userRolesIds.approverUpdatePerfil) //Desarrollo Humano
					}

					if (aActualizacionRealizada === true) {
						getNotifyActualizacionRealizada(GlobalConfig.userRolesIds.reviewerUpdatePerfil) //Dirección académica
					   getSendNotifyActualizacionRealizada(vm.info.idUser)//Profesor de la solicitud
					}

					if (aSolicitudRechazada === true) {
						let post1 = {
							idUser                      : vm.info.idUser,
							dsName                      : 'Notificación de solicitud a solicitud rechazada',
							dsDescription               : 'Profesor: Su solicitud de actualización del perfil fue rechazada, verifique desde el perfil la razón del rechazo.',
							idNotification_delivery_type: GlobalConfig.notificationType.inbox,
							is_grouped                  : 0,
						}

						vm.services.addNotificationsTransactions.add(post1).$promise.then(function (dataReturn) {
							if (dataReturn.status) {
								console.log('ok notification solicitud a solicitud rechazada', dataReturn)
							} else {
								console.log('Error Comunications')
							}
						}, function (data) {
							console.log(data)
						})
					}

					if (vm.$scope.uploader.queue.length > 0) {
						vm.logIdInsert = response.data
						for (var i = 0 ; i < vm.$scope.uploader.queue.length; i++) {
							vm.$scope.uploader.queue[i].url = vm.$scope.uploader.url + '?userId=' + vm.identificationNumber + '&requestId=' + vm.dataToUpdate.NTicket + '&logId=' + vm.logIdInsert
						}
						vm.$scope.uploader.uploadAll()
					} else {
						vm.$state.go('profile.Actualizacion_Perfil')
						vm.ngNotify.set('Perfil actualizado exitosamente!', 'success')
						vm.isSaveButtonDisabled = false
					}
				} else {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error')
					vm.isSaveButtonDisabled = false
				}
			}, (err) => {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error')
				vm.isSaveButtonDisabled = false
			})
		}

		function getFile(logId, fileName) {
			let params = {
				requestId: vm.dataToUpdate.NTicket,
				userId   : vm.identificationNumber,
				logId    : logId,
				fileName : fileName,
			}

			vm.services.getFileSrv.getFile(params).$promise.then((response) => {
				if (response.status) {
					const file = new Buffer.from(response.data.data)
					const blob = new Blob([ file ])
					const link = document.createElement('a')
		
					link.href = window.URL.createObjectURL(blob)
		
					link.download = fileName
					link.click()

					return 
				} else {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error')
				}
			})
		}

		function getFilesBitacora(logId) {
			vm.services.getFileBitacoraSrv.getFiles({ logId: logId }).$promise.then((response) => {
				if (response.status) {
					vm.fileList = response.data
				} else {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error')
				}
			}, (err) => {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}
	   function activateModal (logId) {
		   vm.services.getFileBitacoraSrv.getFiles({ logId: logId }).$promise.then((response) => {
				if (response.status) {
					let filesDownload = response.data

					$mdDialog.show({
						controller: [ '$scope', '$mdDialog', '$state', function modalActivateWorkPlan ($scope, $mdDialog, $state) {
							$scope.getFile = vm.getFile
							$scope.files = filesDownload
							$scope.logId = logId
							$scope.close = () => {
								$mdDialog.hide()
							}
						} ],
						template           : require('./modalFilesDownload.html'),
						clickOutsideToClose: false,
					})
				} else {
					vm.ngNotify.set('Imposible conectar con el servicio', 'error')
				}
			}, (err) => {
				vm.ngNotify.set('Imposible conectar con el servicio', 'error')
			})
		}
		function validateForm(form) { 
      		if (typeof form !== 'undefined')
			  return form.$invalid
    	}
		function hasError(input) {
			if (typeof input !== 'undefined' && input.$invalid && (input.$dirty || input.$touched)) {
				return 'has-error'
			}
		}
		function showErrorMessages(input) {
			if (input)
				return input.$dirty || input.$touched
			else
				return false
		}
	}

}

updateDataProfileCtrl.$inject = [ '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'perfilSrv', '$cookies', 'moment', 'GlobalConfig',
	'FileUploader', 'SERVICE_URL_CONSTANT', '$window', '$mdDialog', 'GlobalSrv' ]


// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/Actualizacion_Perfil/updateDataProfileCtrl.js